function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M0 1.5A1.5 1.5 0 011.5 0h7A1.5 1.5 0 0110 1.5v5A1.5 1.5 0 018.5 8h-7A1.5 1.5 0 010 6.5v-5zM1.5 1a.5.5 0 00-.5.5v5a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-5a.5.5 0 00-.5-.5h-7zm2.585 10A1.5 1.5 0 005.5 12h3A5.5 5.5 0 0014 6.5v-1a1.5 1.5 0 00-1-1.415V6.5A4.5 4.5 0 018.5 11H4.085zM3.5 10a1.5 1.5 0 01-1.415-1H8.5A2.5 2.5 0 0011 6.5V2.085A1.5 1.5 0 0112 3.5v3A3.5 3.5 0 018.5 10h-5z",
  fill: "#6264A7"
});

function SvgLifecycleTaskIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgLifecycleTaskIcon;